<template>
  <div class="planning-pool-shipping-point">
    <InfoIcon
      v-if="
        shipOrder.planningStatus === PlanningStatus.PARTIALLY_PLANNED &&
        shippingPoint.planningStatus === PlanningStatus.UNPLANNED
      "
      icon="pi pi-exclamation-triangle"
      :tooltip="t('routeBuilder.unresolvedShipOrderMessage')"
    />
    <ShippingPointSearchResult :shipping-point="shippingPoint" />
  </div>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue';
import { toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import {
  PlanningStatus,
  ValidShipOrder,
  ValidShipOrderShippingPoint,
} from '@/model/routeBuilder';

import ShippingPointSearchResult from '@/components/search/ShippingPointSearchResult.vue';
import InfoIcon from '@rygen/rygen-ui/components/ui/InfoIcon.vue';

const props = defineProps({
  shippingPoint: {
    type: Object as PropType<ValidShipOrderShippingPoint>,
    required: true,
  },
  shipOrder: {
    type: Object as PropType<ValidShipOrder>,
    required: true,
  },
});
const { shippingPoint, shipOrder } = toRefs(props);

const { t } = useI18n();
</script>

<style>
.planning-pool-shipping-point {
  display: flex;
  gap: var(--sp-2);
  align-items: center;

  .info-icon-container {
    color: var(--warning-color);
  }
}
</style>
